var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H7C4.79086 15 3 16.7909 3 19V20",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 20.9501C12.1 20.9777 12.0776 21 12.05 21C12.0224 21 12 20.9776 12 20.95C12 20.9224 12.0224 20.9 12.05 20.9C12.0776 20.9 12.1 20.9223 12.1 20.95V20.9501",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09999 20.9501C9.09995 20.9777 9.07756 21 9.04996 21C9.02236 21 8.99999 20.9776 8.99999 20.95C8.99999 20.9224 9.02236 20.9 9.04996 20.9C9.07756 20.9 9.09995 20.9223 9.09999 20.95V20.9501",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7.00002,
    r: 4,
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9585 20.95H15.5C15.2239 20.95 15 20.7261 15 20.45V18.9915C15 18.7263 15.1054 18.4719 15.2929 18.2844L18.3344 15.2429C18.5219 15.0554 18.7763 14.95 19.0415 14.95C19.3067 14.95 19.5611 15.0554 19.7486 15.2429L20.7071 16.2014C21.0976 16.5919 21.0976 17.2251 20.7071 17.6156L17.6656 20.6571C17.478 20.8447 17.2237 20.95 16.9585 20.95Z",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepicon);
export default __webpack_public_path__ + "static/media/stepicon.e5ca4f29156bb10473dcad87eaf06c62.svg";
export { ForwardRef as ReactComponent };